import { reducer as PowertrainConfigurationReducer } from './PowertrainConfiguration/PowertrainConfigurationReducer';
import { reducer as PowertrainConfigurationReducerV2 } from './PowertrainConfigurationV2/PowertrainConfigurationReducer';
import { reducer as SubscriptionStatusReducer } from './SubscriptionStatus/SubscriptionStatusReducer';
import { reducer as PowertrainWizardReducer } from './PowertrainConfiguration/PowertrainWizard/PowertrainWizardReducer';
import { reducer as PowertrainWizardReducerV2 } from './PowertrainConfigurationV2/PowertrainWizard/PowertrainWizardReducer';
import { reducer as GatewayListReducer, gatewayTypeReducer as GatewayTypeReducer, driveApplicationsReducer as DriveApplicationReducer } from './GatewayManagement/GatewayManagementReducer';
import { reducer as GatewayInfoReducer, connectedAssetReducer as GatewayConnectedAssetsReducer, userCapabilitiesReducer as GatewayUserCapabilitiesReducer, validateGatewayAssetReducer as GatewayValidateAssetReducer, validateSwitchGatewayAssetReducer as GatewayValidateSwitchAssetReducer, installationReportReducer, downloadDiagnosticReportReducer, connectionHistoryGatewayReducer, connectionHistoryAssetReducer, connectedHistoryReducer } from './GatewayManagement/GatewayDetails/GatewayDetailsReducer';
import { RebootGatewayReducer } from './GatewayManagement/GatewayDetails/Header/RebootGateway/RebootGatewayReducer';
import { reducer as SerialNumberEditorReducer } from './GatewayManagement/SerialNumberEditor/SerialNumberEditorReducer';
import { reducer as GatewayEventsLogReducer } from './GatewayManagement/GatewayEvents/GatewayEventsReducer';
import { ActivateDeactivateGatewayReducer, lastCommandStatusReducer as LastCommandStatusReducer } from './GatewayManagement/GatewayDetails/Header/ActivateDeactivateGateway/ActivateDeactivateGatewayReducer';


import { combineReducers } from 'redux';
import { reducer as SensorFirmwareManagementReducer } from './SensorFirmwareManagement/SensorFirmwareManagementReducer';
import { UpdateFirmwareReducer } from './GatewayManagement/GatewayDetails/Header/UpdateFirmware/UpdateFirmwareReducer';
import { RefreshGatewayReducer } from './GatewayManagement/GatewayDetails/Header/RefreshGateway/RefreshGatewayReducer';
import { DeleteGatewayReducer } from './GatewayManagement/GatewayDetails/Header/DeleteGateway/DeleteGatewayReducer';
import { DeleteAssetReducer } from './GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/DeleteAsset/DeleteAssetReducer';
import { ExportMessageArchiveReducer } from './GatewayManagement/GatewayDetails/Header/ExportMessageArchive/ExportMessageArchiveReducer';

export const reducer = combineReducers({
    configuration: PowertrainConfigurationReducer,
    configurationV2: PowertrainConfigurationReducerV2,
    subscriptionStatus: SubscriptionStatusReducer,
    wizard: PowertrainWizardReducer,
    wizardV2: PowertrainWizardReducerV2,
    gateway: GatewayListReducer,
    sensorFirmwareManagement: SensorFirmwareManagementReducer,
    gatewayInformation: GatewayInfoReducer,
    gatewayConnectedAssets: GatewayConnectedAssetsReducer,
    gatewayType: GatewayTypeReducer,
    serialNumberEditor: SerialNumberEditorReducer,
    userCapabilities: GatewayUserCapabilitiesReducer,
    validateGatewayAsset: GatewayValidateAssetReducer,
    validateSwitchGatewayAsset: GatewayValidateSwitchAssetReducer,
    driveApplications: DriveApplicationReducer,
    lastCommandStatus: LastCommandStatusReducer,
    gatewayEventsLog: GatewayEventsLogReducer,
    rebootGateway: RebootGatewayReducer,
    updateFirmware: UpdateFirmwareReducer,
    refreshGateway: RefreshGatewayReducer,
    activateDeactivateGateway: ActivateDeactivateGatewayReducer,
    deleteGateway: DeleteGatewayReducer,
    exportMessageArchive: ExportMessageArchiveReducer,
    installationReport: installationReportReducer,
    deleteAsset: DeleteAssetReducer,
    downloadDiagnosticReport: downloadDiagnosticReportReducer,
    connectionHistoryGateway: connectionHistoryGatewayReducer,
    connectionHistoryAsset: connectionHistoryAssetReducer,
    connectedHistory: connectedHistoryReducer
});
